import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({ 
      pageProps: "pagePropertiesStore/getPageProperties"
    })
  },
  created () {
    this.setPageProperties(this.pageSettings)
  },
  methods: {
    ...mapActions({ 
      setPageProperties: "pagePropertiesStore/setPageProperties"
    }),
  }
}